import styles from './PropertySpyCard.module.css'
import { ImageSlider } from 'shared/ui/strspykit/ImageSlider'
import CloseIcon from '@mui/icons-material/Close'
import { Button, IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import { UnderObservationDoubleIcon } from 'shared/icons/UnderObservationDoubleIcon'
import { ImageSlider2 } from 'shared/ui/strspykit/ImageSlider2'

interface PropertySpyCardProps {
    propertySpy: any
    onDelete: (event: any) => void 
}

export const PropertySpyCard = (props: PropertySpyCardProps) => {
    const {
        propertySpy,
        onDelete
    } = props

    const slides: any = []
    propertySpy?.strHostServicePicture.forEach((pictureUrl: string) => {
        slides.push({
            title: '',
            src: pictureUrl,
            id: pictureUrl
        })
    })

    const position = propertySpy.hostRank

    const handleDeleteButton = (event: any) => {
        onDelete?.({
            hostServiceId: propertySpy.strHostServiceId,
            spyId: propertySpy.strMonitorId
        })
    }

    const costText = propertySpy?.price === undefined ? `` : `$${propertySpy?.price}`

    return (
        <div className={styles.PropertySpyCard__Root}>
            <div className={styles.PropertySpyCard__ImageSliderContainer}>
                <ImageSlider2
                    images={slides}
                />
                <div className={styles.PropertySpyCard__UnderObservation}>
                    <UnderObservationDoubleIcon
                        className={styles.PropertySpyCard__UnderObservationIcon}
                    />
                    <div className={styles.PropertySpyCard__UnderObservationBg}>

                    </div>
                </div>
                <div className={styles.PropertySpyCard__PositionContainer}>
                    <div className={styles.PropertySpyCard__Position}>
                        <div className={styles.PropertySpyCard__PositionLabel}>
                            Position:
                        </div>
                        <div className={styles.PropertySpyCard__PositionValue}>
                            {position}
                        </div>
                    </div>
                </div>
                <div className={styles.PropertySpyCard__Cost}>
                    <div className={styles.PropertySpyCard__CostValue}>
                        {costText}
                    </div>
                </div>
                <div className={styles.PropertySpyCard__CloseButtonContainer}>
                    <IconButton
                        className={styles.PropertySpyCard__CloseButton}
                        aria-label=""
                        size="small"
                        onClick={handleDeleteButton}
                    >
                        <CloseIcon fontSize="medium" />
                    </IconButton>
                </div>
            </div>
            <div className={styles.PropertySpyCard__NameContainer}>
                <div className={styles.PropertySpyCard__Name}>
                    {propertySpy.strHostServiceName}
                </div>

            </div>
            <div className={styles.PropertySpyCard__MainToolbar}>
                <Link 
                    className={styles.PropertySpyCard__DetailsLink}
                    to={`/hostservice/${propertySpy.strHostServiceId}?monitoridforprices=${propertySpy.strMonitorId}`}
                >
                    <Button
                        className={styles.PropertySpyCard__Button}
                        color="success"
                        variant="contained"
                        sx={{
                            fontSize: '20px',
                            textTransform: 'none'
                        }}
                    >
                        Details
                    </Button >
                </Link>
                <Link 
                    className={styles.PropertySpyCard__SeeChangesLink}
                    to={`/propertyspy/${propertySpy.id}`}
                >
                    <Button
                        className={styles.PropertySpyCard__Button}
                        color="success"
                        variant="outlined"
                        sx={{
                            textTransform: 'none',
                            borderWidth: '2px!important',
                            background: `#FFFF`
                        }}
                    >
                    See changes
                    </Button >
                </Link>
            </div>

        </div>
    )
}